module.exports = __webpack_public_path__ + "img/iso2.1b639208.png";